<div class="p-inputgroup">
  <crm-input-text
    #inputElement
    [(value)]="subject"
    (valueChange)="subjectChange.emit($event)"
    (onBlur)="showTemplateOptions = false"
    class="w-full"
    [isError]="isError"></crm-input-text>
  <button
    type="button"
    pButton
    label="{x}"
    (click)="showTemplateOptions = !showTemplateOptions"></button>
</div>

<div
  class="relative z-1 scalein animation-duration-100"
  [ngClass]="showTemplateOptions ? 'block' : 'hidden'">
  <div class="absolute mt-1 shadow-4 border-round">
    <p-listbox
      *ngIf="showTemplateOptions"
      [options]="templateOptions"
      (onChange)="onTemplateOptionSelect($event.value, inputElement.input.nativeElement)"
      [listStyle]="{ 'max-height': '250px' }"
      listStyleClass="compact-list">
      <ng-template
        let-option
        pTemplate="item"
        >{{ option }}</ng-template
      >
    </p-listbox>
  </div>
</div>
